module.exports = __webpack_public_path__ + "media/images/admin/icons/database-562a8409470b0f5086e6b76e14588b6a.svg";